import '../base/header_2026';
import { contractInit } from '../base/contract';

contractInit('in', 'TalkingData官网', 1);
